(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-collection-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tcc-carousel').forEach(function (carousel) {
    const swiperEl = carousel.querySelector('.tcc-swiper');
    const prevBtn = carousel.querySelector('.swiper-button-prev');    
    const nextBtn = carousel.querySelector('.swiper-button-next');

    if (!swiperEl) return;

new Swiper(swiperEl, {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 16,
  centeredSlides: false,
  loopAddBlankSlides: true, // Helps if slide count is uneven
  navigation: {
    prevEl: prevBtn,
    nextEl: nextBtn        
  },
  breakpoints: {
    990: {
      slidesPerView: 3,
      spaceBetween: 24
    }
  }
});
  });
});





  } catch(e) { console.error(e); }
})();
})();
